import { StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';

import { type RemainingRecordingSeverity } from '@/models/recordingDuration';

import { remainingSeverityStyles, TEXT_ND_SECONDARY } from './remainingSeverityStyles';

interface RecordingRemainingTimeProps {
  readonly label: string;
  readonly severity?: RemainingRecordingSeverity;
}

export const RecordingRemainingTime = ({
  label,
  severity = 'normal',
}: RecordingRemainingTimeProps) => (
  <Text testID="recording-remaining-time" style={[styles.label, remainingSeverityStyles[severity]]}>
    {label}
  </Text>
);

const styles = StyleSheet.create({
  label: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'center',
    color: TEXT_ND_SECONDARY,
  },
});
